/* eslint-disable no-console */
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GaAuthService } from '@ga/central-auth-angular';
import { RuntimeConfigurationService } from 'gain-web/shared-modules/runtime-configuration/runtime-configuration.service';

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss'],
  standalone: false,
})
export class SessionTimeoutDialogComponent {
  logoutPageUrl: string;

  constructor(
    private authService: GaAuthService,
    private dialogRef: MatDialogRef<SessionTimeoutDialogComponent, boolean>,
    private runtimeConfig: RuntimeConfigurationService,
  ) {
    const { logoutPageUrl } = this.runtimeConfig.get().authOptions;
    this.logoutPageUrl = logoutPageUrl;
  }

  async logoutUser() {
    console.log('session logout triggered');
    await this.authService.logout(true);
    this.dialogRef.close(false);
    window.location.href = this.logoutPageUrl + '?allowLogout=true';
  }

  reauthenticate() {
    const newWindow = window.open(
      this.runtimeConfig.get().authOptions.loginPageUrl,
      '_blank',
    );
    window.focus();

    this.authService.reauthenticate(() => {
      newWindow?.close();
      this.dialogRef.close(true);
    });
  }
}
